export default __webpack_public_path__ + "static/media/Box Sticker_Dynamex_Artboard 4@3x.af0d0de9.png";